import React from 'react';
import { Formik } from 'formik';
import { VALIDATION } from 'helpers/constants';
import { useStore } from 'hooks';
import { ChangePassword } from 'components/profile';
import { AuthService } from 'services';
import * as Yup from 'yup';

const ChangePasswordValidationSchema = Yup.object().shape({
  oldPassword: Yup.string()
    .min(5, 'Пароль должен быть от 5 до 16 символов')
    .max(16, 'Пароль должен быть от 5 до 16 символов')
    .required(...VALIDATION.REQUIRED),
  password: Yup.string()
    .min(5, 'Пароль должен быть от 5 до 16 символов')
    .max(16, 'Пароль должен быть от 5 до 16 символов')
    .required(...VALIDATION.REQUIRED),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('password')], 'Пароли не совпадают')
    .required(...VALIDATION.REQUIRED),
});

const ChangePasswordColumn = () => {
  const { setLoading, setUser } = useStore();
  const initialValues = {
    oldPassword: '',
    password: '',
    confirmPassword: '',
  };

  const onSubmit = async (values) => {
    const authService = new AuthService({ setUser });
    setLoading(true);
    await authService.updatePassword({ ...values });
    setLoading(false);
  };

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={ChangePasswordValidationSchema}
      onSubmit={onSubmit}
    >
      {({ handleSubmit, isValid }) => (
        <ChangePassword onSubmit={handleSubmit} isValid={isValid} />
      )}
    </Formik>
  );
};

export default ChangePasswordColumn;
